import request from '@/utils/request';

// 根据报告类型获取接口前缀
function getReportPrefix(reportType) {
  return reportType === 'order' ? '/orders/order-report' : '/orders/package-report';
}

/**
 * 获取组件面板
 * @param {*} params
 * @param {string} [reportType] - 报告类型，'order'为非礼包服务报告
 * @returns
 */
export function getComponents(params, reportType) {
  return request({
    url: "".concat(getReportPrefix(reportType), "/widget"),
    method: 'get',
    timeout: 30 * 1000,
    params: params
  });
}

/**
 * 获取主数据
 * @param {*} params
 * @param {string} [reportType] - 报告类型，'order'为非礼包服务报告
 * @returns
 */
export function loadHomeData(params, reportType) {
  return request({
    url: "".concat(getReportPrefix(reportType), "/index"),
    method: 'get',
    params: params
  });
}

/**
 * 单组件更新
 * @param {*} data
 * @param {string} [reportType] - 报告类型，'order'为非礼包服务报告
 * @returns
 */
export function update(data, reportType) {
  return request({
    url: "".concat(getReportPrefix(reportType), "/widget-save"),
    method: 'post',
    data: data
  });
}
/**
 * 发布保存
 * @param {*} data
 * @param {string} [reportType] - 报告类型，'order'为非礼包服务报告
 * @returns
 */
export function submit(data, reportType) {
  return request({
    url: "".concat(getReportPrefix(reportType), "/submit"),
    method: 'post',
    data: data
  });
}

/**
 * 获取二维码预览信息
 * @param {*} data
 * @returns
 */
export function getQrcodeInfo(data, reportType) {
  var reportPath = reportType === 'order' ? 'order-report' : 'package-report';
  var url = {
    production: "https://packageapi.youlianfuwu.com/preview/".concat(reportPath, "/qrcode"),
    test: "https://packageapitest.youlianfuwu.com/preview/".concat(reportPath, "/qrcode"),
    dev: "https://packageapi.dev.youlianfuwu.com/preview/".concat(reportPath, "/qrcode")
  }[process.env.VUE_APP_NAME];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

/**
 * 刷新数据
 * @param {*} data
 * @returns
 */
export function refreshData(data, reportType) {
  return request({
    url: "".concat(getReportPrefix(reportType), "/refresh"),
    method: 'post',
    timeout: 15 * 1000,
    data: data
  });
}

/**
 * 导出礼包服务报告
 * @param {*} data
 * @returns
 */
export function exportReportData(data, reportType) {
  return request({
    url: "".concat(getReportPrefix(reportType), "/export"),
    method: 'post',
    data: data
  });
}

/**
 * 导出PPT
 * @param {*} data
 * @returns
 */
export function exportPptData(data) {
  return request({
    url: '/orders/order-report/export-ppt',
    method: 'post',
    data: data
  });
}

// 获取订单发送短信记录详情
export function getSmsSendDetail(data) {
  return request({
    url: '/orders/order/sms-log-detail',
    method: 'post',
    data: data
  });
}
// 虚拟 退卡售卡详情
export function orderSaleBasInfo(data) {
  return request({
    url: '/orders/cardsale/base-info',
    method: 'post',
    data: data
  });
}

// 获取优享订单
export function getSelfOrderChoose(data) {
  return request({
    url: '/orders/order/get-self-choose',
    method: 'post',
    data: data
  });
}
// 设置优享订单
export function saveSelfOrderChoose(data) {
  return request({
    url: '/orders/order/set-self-choose',
    method: 'post',
    data: data
  });
}
// 添加优享订单
export function addSelfOrderChoose(data) {
  return request({
    url: '/orders/order/add-self-choose',
    method: 'post',
    data: data
  });
}
// 编辑优享订单
export function editSelfOrderChoose(data) {
  return request({
    url: '/orders/order/up-self-choose',
    method: 'post',
    data: data
  });
}
// 编辑优享订单状态
export function editSelfOrderChooseStatus(data) {
  return request({
    url: '/orders/order/up-self-choose-status',
    method: 'post',
    data: data
  });
}
// 编辑优享订单状态
export function getOrderMenus(data) {
  return request({
    url: '/orders/order/get-order-menus',
    method: 'post',
    data: data
  });
}
// 获取规则菜单
export function getOrderRuleMenu(params, ruleType, entryType) {
  var url = {
    order: '/orders/order/rule-menus',
    cardType: '/orders/new-card-rule/index-menus'
  }[ruleType];
  var url1 = {
    platformQueryManage: '/plat/order/channel-rule-menus',
    serviceCenter: '/orders/order/channel-rule-menus'
  }[entryType];
  return request({
    url: url1 ? url1 : url,
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 设置功能菜单
export function setOrderRuleMenu(data, ruleType) {
  var url = {
    order: '/orders/order/set-rule-menus',
    cardType: '/orders/new-card-rule/update-default-rule-menus'
  }[ruleType];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 编辑优享订单状态
export function packageReportLog(data, reportType) {
  return request({
    url: "".concat(getReportPrefix(reportType), "/on-log"),
    method: 'post',
    data: data
  });
}

/**
 * 特殊账期配置相关接口
 */

/**
 * 获取特殊账期配置列表
 * @param {Object} data - 查询参数
 * @param {number} data.page - 当前页码
 * @param {number} data.pageSize - 每页条数
 */
export function getSpecialPaymentList(data) {
  return request({
    url: '/orders/special-payment-config/list',
    method: 'post',
    data: data
  });
}

/**
 * 添加特殊账期配置
 * @param {Object} data - 配置数据
 */
export function addSpecialPayment(data) {
  return request({
    url: '/orders/special-payment-config/add',
    method: 'post',
    data: data
  });
}

/**
 * 修改特殊账期配置
 * @param {Object} data - 配置数据
 */
export function updateSpecialPayment(data) {
  return request({
    url: '/orders/special-payment-config/up',
    method: 'post',
    data: data
  });
}

/**
 * 删除特殊账期配置
 * @param {Object} data - { id }
 */
export function deleteSpecialPayment(data) {
  return request({
    url: '/orders/special-payment-config/del',
    method: 'post',
    data: data
  });
}
// 获取订单售卡风险校验
export function getOrderAuditRisk(data) {
  return request({
    url: '/orders/cardsale/audit-risk',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 获取订单售卡风险校验
export function setOrderAuditRistConfig(data) {
  return request({
    url: '/orders/order/set-order-audit-risk',
    method: 'post',
    data: data
  });
}
// 优享订单关联订单
export function setSelfChooseOrder(data) {
  return request({
    url: '/orders/order/set-self-choose-order',
    method: 'post',
    data: data
  });
}
// 优享订单关联订单
export function getSelfChooseOrder(data) {
  return request({
    url: '/orders/order/get-self-choose-order',
    method: 'post',
    data: data
  });
}
// 售卡订单列表
export function getSellCardOrderList(data) {
  return request({
    url: '/orders/voucher-order/list',
    method: 'post',
    data: data
  });
}
// 获取退卡售卡列表
export function getVoucherOrderCardList(data) {
  return request({
    url: '/orders/voucher-order/card-list',
    method: 'post',
    data: data
  });
}
// 获取解密客户名称
export function viewCustomerName(data) {
  return request({
    url: '/orders/order/get-customer-name-by-sale-id',
    method: 'post',
    data: data
  });
}

// 我的商城账号列表
export function getShopAccount(params) {
  return request({
    url: '/user/shop-account/index',
    method: 'get',
    params: params
  });
}

//验收-基本信息
export function getTestCardInfo(params) {
  return request({
    url: '/orders/test-cards/index',
    method: 'get',
    params: params
  });
}

// 绑卡
export function bindCard(data) {
  return request({
    url: '/orders/test-cards/bind-card',
    method: 'post',
    data: data
  });
}

// 获取渠道公众号二维码
export function getLoginUrl(params) {
  return request({
    url: '/user/channel/get-login-url',
    method: 'get',
    params: params
  });
}
// 获取渠道小程序二维码
export function getLoginImg(params) {
  return request({
    url: '/user/channel/get-login-img',
    method: 'get',
    params: params
  });
}

// 用户信息 - 获取渠道用户绑卡信息
export function getUserCardList(params) {
  return request({
    url: '/user/channel-user/channel-user-card-list',
    method: 'get',
    params: params
  });
}

//类型列表
export function searchTypes(params) {
  return request({
    url: '/orders/shop-orders/search-types',
    method: 'get',
    params: params
  });
}

// 订单列表
export function orderList(params) {
  return request({
    url: '/orders/shop-orders/list',
    method: 'get',
    params: params
  });
}

// 更改账号状态
export function changeUserStataus(data) {
  return request({
    url: '/orders/test-cards/change-user-status',
    method: 'post',
    data: data
  });
}
// 获取搭售订单列表
export function getBundlingOrderList(data) {
  return request({
    url: '/orders/coupon/child-order',
    method: 'post',
    data: data
  });
}

// 获取模拟登录地址
export function getMockLoginUrl(data) {
  return request({
    url: '/orders/test-cards/mock-login',
    method: 'post',
    data: data
  });
}
// 关联订单
export function setConnectOrder(data) {
  return request({
    url: '/orders/coupon/set-coupon-order',
    method: 'post',
    data: data
  });
}
// 订单审核查看脱敏
export function viewOrderAuditCustomerName(data) {
  return request({
    url: '/orders/order/get-customer-name-to-audit-list',
    method: 'post',
    data: data
  });
}

// 关联订单
export function upCouponFile(data) {
  return request({
    url: '/orders/coupon/up-coupon-file',
    method: 'post',
    data: data
  });
}

//获取配置白名单分类配置
export function getExchangeWhiteListType(data) {
  return request({
    url: '/orders/offline-buy-exchange/get-type',
    method: 'post',
    data: data
  });
}

//开启关闭配置
export function openCloseConfig(data) {
  return request({
    url: '/orders/offline-buy-exchange/open',
    method: 'post',
    data: data
  });
}

//白名单列表
export function getExchangeWhiteList(params) {
  return request({
    url: '/orders/offline-buy-exchange/index',
    method: 'get',
    params: params
  });
}

//白名单-添加&&编辑
export function upExchangeWhiteList(data) {
  return request({
    url: '/orders/offline-buy-exchange/up',
    method: 'post',
    data: data
  });
}

//白名单-删除
export function delExchangeWhiteList(data) {
  return request({
    url: '/orders/offline-buy-exchange/del',
    method: 'post',
    data: data
  });
}

// 下载模板
export function templateDownload(data) {
  return request({
    url: '/orders/template/download',
    method: 'post',
    data: data
  });
}

// 导入白名单-校验
export function importExchangeWhiteList(data) {
  return request({
    url: '/orders/offline-buy-exchange/upload',
    method: 'post',
    data: data
  });
}

// 白名单-确认上传接口
export function importExchangeWhiteListSubmit(data) {
  return request({
    url: '/orders/offline-buy-exchange/upload-submit',
    method: 'post',
    data: data
  });
}
// 获取自动搭售列表
export function getCouponConfigList(data) {
  return request({
    url: '/orders/coupon/get-coupon-config-list',
    method: 'post',
    data: data
  });
}
// 创建自动搭售
export function addCouponConfig(data) {
  return request({
    url: '/orders/coupon/add-coupon-config',
    method: 'post',
    data: data
  });
}

// 编辑自动搭售
export function upCouponConfig(data) {
  return request({
    url: '/orders/coupon/up-coupon-config',
    method: 'post',
    data: data
  });
}
// 启用禁用自动搭售
export function upCouponConfigStatus(data) {
  return request({
    url: '/orders/coupon/set-coupon-config-status',
    method: 'post',
    data: data
  });
}
// 获取优选自动搭售列表
export function getSelfBundlingList(data) {
  return request({
    url: '/orders/coupon/get-self-coupon-list',
    method: 'post',
    data: data
  });
}
// 优选添加搭售订单
export function addEnjoyBundlingOrder(data) {
  return request({
    url: '/orders/coupon/set-self-coupon',
    method: 'post',
    data: data
  });
}
// 优选编辑搭售订单状态
export function upEnjoyBundlingOrderStatus(data) {
  return request({
    url: '/orders/coupon/set-self-coupon-status',
    method: 'post',
    data: data
  });
}
// 优选编辑搭售订单
export function upEnjoyBundlingOrder(data) {
  return request({
    url: '/orders/coupon/up-self-coupon',
    method: 'post',
    data: data
  });
}
// 批量检查售卡
export function batchCheckSellCard(params) {
  return request({
    url: '/orders/cardsale/batch-check-audit',
    method: 'get',
    params: params
  });
}
// 批量激活售卡
export function cardSaleBatchAudit(params) {
  return request({
    url: '/orders/cardsale/batch-audit',
    method: 'get',
    params: params
  });
}
// 联合跟进列表
export function jointFollowList(data) {
  return request({
    url: '/orders/customer/customer-order-partner',
    method: 'post',
    data: data
  });
}
// 添加跟进列表
export function addJointFollow(data) {
  return request({
    url: '/orders/customer/add-partner',
    method: 'post',
    data: data
  });
}
// 删除跟进列表
export function delJointFollow(data) {
  return request({
    url: '/orders/customer/del-partner-by-customer-id',
    method: 'post',
    data: data
  });
}
// 获取联合跟进信息
export function getJointFollowDetail(data) {
  return request({
    url: '/orders/customer/customer-partner-detail',
    method: 'post',
    data: data
  });
}
// 编辑跟进列表
export function editJointFollow(data) {
  return request({
    url: '/orders/customer/up-partner',
    method: 'post',
    data: data
  });
}
// 获取供应商列表
export function getCustomerList(data) {
  return request({
    url: '/orders/customer/list',
    method: 'post',
    data: data
  });
}
// 获取联合跟进人列表
export function getPartnerUserList(data) {
  return request({
    url: '/user/new-user-count/user-ids',
    method: 'post',
    data: data
  });
}
// 获取订单 促销方案兑换列表
export function getProgrammePlanRecord(params) {
  return request({
    url: '/package/package-programme/programme-plan-record',
    method: 'get',
    params: params
  });
}
// 获取订单 促销方案兑换详情
export function getProgrammePlanStatistics(params) {
  return request({
    url: '/package/package-programme/programme-plan-record-statistics',
    method: 'get',
    params: params
  });
}
// 获取订单 促销方案 方案名称
export function getProgrammeName(params) {
  return request({
    url: '/package/package-programme/get-name-info',
    method: 'get',
    params: params
  });
}
// 获取订单 促销方案的礼包列表
export function getProgrammePlanRecordPackage(params) {
  return request({
    url: '/package/package-programme/programme-plan-record-package',
    method: 'get',
    params: params
  });
}
// 获取订单 促销方案的礼包列表
export function getProgrammePlanRecordPackageSta(params) {
  return request({
    url: '/package/package-programme/programme-plan-record-package-sta',
    method: 'get',
    params: params
  });
}
// 获取礼包兑换详情
export function getProgrammePlanRecordPackageDetail(params) {
  return request({
    url: '/package/package-programme/programme-plan-record-package-detail',
    method: 'get',
    params: params
  });
}
// 获取项目列表售卡详情
export function getProjectOrderCardList(data) {
  return request({
    url: '/orders/voucher-order/card-info-list',
    method: 'post',
    data: data
  });
}
// 获取项目列表售卡详情管理权限
export function getProjectManageOrderCardList(data) {
  return request({
    url: '/orders/voucher-order/manage-card-info-list',
    method: 'post',
    data: data
  });
}

/**
 * 电子签名抽屉 - 跳转目标相关接口
 * 独立于装修模块（custom-layout/api），避免多处复用引发参数、模块差异
 */

/**
 * 电子签名 - 获取菜单列表
 * @param {Object} params - { customer_id }
 * @returns
 */
export function getCategory(params) {
  return request({
    url: '/decoration/decoration/category',
    method: 'get',
    params: params
  });
}

/**
 * 电子签名 - 获取子页面列表
 * @param {Object} params - { customer_id }
 * @returns
 */
export function getChildPageList(params) {
  return request({
    url: '/decoration/decoration/child-page-list-customer',
    method: 'get',
    params: params
  });
}

/**
 * 电子签名 - 获取礼包方案列表
 * @param {Object} params - { customer_id }
 * @returns
 */
export function getCustomerPackage(params) {
  return request({
    url: '/decoration/decoration/get-customer-package',
    method: 'get',
    params: params
  });
}

/**
 * 电子签名 - 获取系统功能菜单
 * @param {Object} params
 * @returns
 */
export function getSystemMenus(params) {
  return request({
    url: '/decoration/decoration/get-system-menus',
    method: 'get',
    params: params
  });
}

/**
 * 电子签名 - 获取智慧工会/SaaS板块列表
 * @param {Object} params - { customer_id }
 * @returns
 */
export function getUnionModulePlate(params) {
  return request({
    url: '/decoration/decoration/get-union-module-plate',
    method: 'get',
    params: params
  });
}

/**
 * 电子签名 - 根据板块获取SaaS活动列表
 * @param {Object} params - { module_plate_id, customer_id }
 * @returns
 */
export function getUnionActivity(params) {
  return request({
    url: '/decoration/decoration/get-union-activity-list',
    method: 'get',
    params: params
  });
}

/**
 * 电子签名 - 获取图书分类列表
 * @param {Object} params - { customer_id, book_type }
 * @returns
 */
export function getBookCategoryList(params) {
  return request({
    url: '/decoration/decoration/get-union-book-cate',
    method: 'get',
    params: params
  });
}

/**
 * 电子签名 - 获取书籍列表
 * @param {Object} params - { customer_id, book_type, module_plate_id, category_name, book_name, pagesize, page }
 * @returns
 */
export function getBookList(params) {
  return request({
    url: '/decoration/decoration/get-union-book-list',
    method: 'get',
    params: params
  });
}